import styled from "styled-components"
import bg from '../../../assets/bg-hero.webp'
import bullet from '../../../assets/bullet.webp'
import { Link as DefaultLink } from '../../link/link'

export const Container = styled.div`
  position: relative;
  width: 100%;
`

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1366px;
`

export const BannerContainer = styled.div`
  background-color: #00A687;
  background-image: url(${bg});
  background-size: cover;
  padding-bottom: 72px;

  @media (max-width: 768px) {
    padding: 32px 0 0;
  }
`

export const BannerWrapper = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
  justify-items: end;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 28px;
    padding: 0 32px;
    overflow: hidden;

    & > div {
      align-items: center;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    & > img {
      margin-top: -72px;
      max-height: none;
      max-width: 150%;
    }
  }
`

export const BannerContent = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  max-width: 616px;
  padding: 40px 0px 40px 40px;

  @media (max-width: 768px) {
    display: flex;
    gap: 16px;
    padding: 0;
    width: 100%;
  }
`

export const Title = styled.h4`
  color: #FFF;
  font-size: 2rem;
  font-weight: 400;
  line-height: 120%;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: -8px;
  }
`

export const Description = styled.p`
  color: #A6FF00;
  font-size: 3rem;
  font-weight: 700;
  line-height: 120%;
  margin-bottom: 40px;
  text-transform: uppercase;

  strong {
    font-weight: bold;
  }

  em, i {
    font-style: italic;
  }

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin: 0;
  }
`

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;

  @media (max-width: 768px) {
    gap: 8px;
  }
`

export const DescriptionTitle = styled.h5`
  color: #FFFFFF;
  font-family: 'Ubuntu';
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    line-height: 28px;
  }
`

export const DescriptionList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 62px;

  @media (max-width: 768px) {
    gap: 8px;
    margin: 0;
  }
`

export const DescriptionListItem = styled.li`
  color: #FFFFFF;
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 120%;

  &::before {
    content: url(${bullet});
    display: inline-block;
    margin-right: 8px;
    position: relative;
    top: 4px;

    @media (max-width: 768px) {
      height: 20px;
      top: 6px;
      width: 20px;
    }
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`

export const Link = styled(DefaultLink)`
  font-size: 24px;
  font-weight: 700;
  line-height: 27.58px;
  padding: 8px 79px;
  width: auto;
`

export const DesktopLink = styled(Link)`
  @media (max-width: 768px) {
    display: none;
  }
`

export const MobileLink = styled(Link)`
  z-index: 1;
  @media (min-width: 767px) {
    display: none;
  }
`

export const DesktopImage = styled.img`
  display: block;
  max-width: 100%;
  @media (max-width: 767px) {
    display: none;
  }
`

export const MobileImage = styled.img`
  display: none;
  max-width: 100%;
  @media (max-width: 767px) {
    display: block;
  }
`

export const Cards = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 64px;

   @media (max-width: 768px) {
    margin: 0;
   }
`

export const Card = styled.div`
  background-color: #007D55;
  border-radius: 10px;
  padding: 24px;


  @media (max-width: 768px) {
    padding: 8px;
  }
`

export const CardTitle = styled.h4`
  color: #A6FF00;
  font-size: 24px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1rem;
    line-height: 120%;
  }
`

export const CardText = styled.p`
  color: #FFFFFF;
  font-size: 24px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1rem;
    line-height: 120%;
  }
`

export const BottomCards = styled.div`
bottom: -92px;
left: 0;
margin-inline: auto;
right: 0;
position: absolute;
max-width: fit-content;

  .swiper {
    & > .container > .cards {
      gap: 16px;
    }
  }
`

export const WhiteCard = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  flex: 0 16.66%;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 144px;
  max-width: 196px;
  min-height: 144px;
  min-width: 196px;
  padding: 16px;
  width: 100%;

  & > img {
    max-width: 24px;
  }
`

export const WhiteCardTitle = styled.h4`
  color: #00A687;
  font-family: "Source Sans 3", sans-serif;
  font-optical-sizing: auto;
  font-size: 14px;
  line-height: normal;
  margin-bottom: 8px;
`

export const WhiteCardText = styled.p`
  color: #084F43;
  font-family: "Source Sans 3", sans-serif;
  font-optical-sizing: auto;
  font-size: 14px;
  line-height: normal;
`
